import IntroRevenueModule from "./IntroRevenueModule";
import Saga from "../../redux/sagas/marketing";
import IntroRevenueReducer from "../../redux/reducers/introRevenue";

export default {
  Component: IntroRevenueModule,
  moduleName: "introRevenue",
  saga: Saga("introRevenue"),
  reducer: IntroRevenueReducer
};
